import { useSidebar } from 'shared-ui';
import { OrbitSidebarTrigger } from '@/components/app/OrbitSidebarTrigger.tsx';
import { useMobileChrome } from '@/components/app/useMobileChrome';

export function MobileSidebarTrigger() {
    const { isMobile, openMobile } = useSidebar();
    const { hideMobileTrigger } = useMobileChrome();

    // Only render when the sidebar is closed. When open, the trigger is rendered
    // inside the sidebar panel itself (AppSidebar) so it is anchored to the panel edge.
    // A route can also claim this corner — the maximised Network Overview table does,
    // since this floating button would sit on top of its title.
    if (!isMobile || openMobile || hideMobileTrigger) {
        return null;
    }

    return (
        <div className="bg-background fixed top-2 left-2 z-40 flex size-15 items-center justify-center rounded-lg border">
            <OrbitSidebarTrigger />
        </div>
    );
}
